/**
 * Copyright 2025 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

const frameRates = [
  {
    label: '60 fps',
    value: 60
  },
  {
    label: '30 fps',
    value: 30
  },
  {
    label: '24 fps',
    value: 24
  },
  {
    label: '15 fps',
    value: 15
  }
];

export {frameRates};